module.exports = "import React from 'react';\nimport { Form, FormGroup, Label, Input } from 'reactstrap';\n\nexport default class Example extends React.Component {\n  render() {\n    return (\n      <Form>\n        <FormGroup check inline>\n          <Label check>\n            <Input type=\"checkbox\" /> Some input\n          </Label>\n        </FormGroup>\n        <FormGroup check inline>\n          <Label check>\n             <Input type=\"checkbox\" /> Some other input\n          </Label>\n        </FormGroup>\n      </Form>\n    );\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/InlineCheckboxes.js
// module id = 371
// module chunks = 0